// 引入 cookie插件
import VueCookie from 'vue-cookie'
// 用户登出
export function saveCookie (res) {
  // 将 UserID 写入 cookie
  VueCookie.set('UserID', res.UserID)
  // 将 UserName 写入 cookie
  VueCookie.set('UserName', res.UserName)
  // 将 SessionID 写入 cookie
  VueCookie.set('SessionID', res.SessionID)
  // 获取用户头像
  VueCookie.set('HeadPictrueUrl', res.HeadPictrueUrl)
}
// 用户登出
export function delUserCookie () {
  // 删除 cookie
  VueCookie.delete('UserID')
  VueCookie.delete('UserName')
  VueCookie.delete('SessionID')
  VueCookie.delete('HeadPictrueUrl')
}



// WEBPACK FOOTER //
// ./src/assets/js/user.js